'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isThursday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isThursday.js
// module id = 558
// module chunks = 0